module.exports = {"pagination":{"BatchGetSecretValue":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListSecretVersionIds":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListSecrets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/secretsmanager-2017-10-17.paginators.json
// module id = 736
// module chunks = 2